module.exports = __webpack_public_path__ + "static/antd-select-loading-b05d702afff7a1aa4f2f1389031deca6.gif";